/**
 * Class constants for the dropdown menu surface.
 *
 * The highlighted state is carried by `data-highlighted` and expressed with a
 * background AND a text colour change, never colour alone.
 */

export const dropdownMenuStyles = {
  trigger:
    'inline-flex items-center justify-center gap-2 rounded-control border border-border-strong bg-surface-raised px-3 py-2 text-sm font-medium text-content transition-colors hover:bg-surface-sunken disabled:pointer-events-none disabled:opacity-50',

  popup:
    'z-50 min-w-48 rounded-surface border border-border bg-surface-raised p-1 text-content shadow-lg transition-opacity duration-100 data-[starting-style]:opacity-0 data-[ending-style]:opacity-0',

  item:
    'flex cursor-default select-none items-center gap-2 rounded-control px-2 py-1.5 text-sm text-content outline-none data-[highlighted]:bg-accent data-[highlighted]:text-accent-content data-[disabled]:pointer-events-none data-[disabled]:opacity-50',

  indicator: 'flex w-4 shrink-0 justify-center',

  label: 'px-2 py-1.5 text-xs font-semibold uppercase text-content-subtle',

  group: 'flex flex-col',

  separator: 'my-1 h-px bg-border',

  arrow: 'block fill-surface-raised stroke-border',
} as const;